export default {
  "content": "<g clip-path=\"url(#clip0_4301_27261)\" fill=\"#717684\"><path d=\"M8 11.733l7.294-5.674A.993.993 0 0015 6H1c-.1.005-.2.025-.294.059L8 11.733z\"/><path d=\"M8.614 13.79a1 1 0 01-1.228 0L0 8.045V15a1 1 0 001 1h14a1 1 0 001-1V8.045L8.614 13.79z\"/></g><defs><clipPath id=\"clip0_4301_27261\"><path fill=\"#fff\" transform=\"translate(0 3)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "22",
    "viewBox": "0 0 16 22",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};